import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { fetchCurrentUser } from '../../actions/reduxActions/currentUser';
import { isNullOrEmpty } from '../../utils/core';
import orgPages, { FLOW_ORG_PAGES } from './orgPages';
import PageSwitcher from '../generic/PageSwitcher';
import Loader from '../Loader';

export const resolveOrgUserRole = (userData, tenantData) => {

    const isTenantInOrg = !isNullOrEmpty(tenantData.organization);
    const isUserAdmin = (!isNullOrEmpty(userData.organizations) && isTenantInOrg)
        ? userData.organizations.some(org => org.id === tenantData.organization.id)
        : false;

    return { isUserAdmin, isTenantInOrg };
};

export const resolveOrgPageId = ({ isUserAdmin, isTenantInOrg }) => (isUserAdmin && isTenantInOrg)
    ? FLOW_ORG_PAGES.flowOrgAdminUI
    : isTenantInOrg
        ? FLOW_ORG_PAGES.flowOrgJoinedUI
        : FLOW_ORG_PAGES.flowOrgNotJoinedUI;

/**
 * @description The wrapper component that figures out which Org page to render
 */
export const InitialOrgPage = ({
    currentUser,
    currentTenant,
    getCurrentUser,
}) => {
    const [orgPageId, setOrgPageId] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        // We need to wait for the user to be loaded every time we enter this screen 
        // in case the user has been removed from the current tenant's organization
        (async function awaitCurrentUser() {
            setIsLoading(true);
            await getCurrentUser(currentUser.authenticationToken);
            setIsLoading(false);
        }());
    }, []);

    useEffect(() => {
        if (currentTenant && currentUser) {
            const userRole = resolveOrgUserRole(currentUser, currentTenant);
            const pageId = resolveOrgPageId(userRole);
            setOrgPageId(pageId);
        }
    }, [currentUser, currentTenant]);


    return isLoading
        ? <Loader />
        : orgPageId
            ? (
                <PageSwitcher 
                    pages={orgPages} 
                    wrapperSelector="flow-organisation" 
                    initialPageId={orgPageId} 
                    currentUser={currentUser} 
                    currentTenant={currentTenant} 
                />
            )
            : null;
};

const mapStateToProps = state => ({
    currentUser: state.currentUser,
    currentTenant: state.currentTenant,
});

const mapDispatchToProps = {
    getCurrentUser: fetchCurrentUser, // using getCurrentUser to appease the linter
};

export default connect(mapStateToProps, mapDispatchToProps)(InitialOrgPage);
